export const aciCocktail = {
    iconName: 'cocktail',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    d: 'M9 21.834h4.8M11.399 21.834v-7.8M3 3.835h2.257a1.2 1.2 0 011.074.663L7.8 7.435',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M17.37 7.435a.601.601 0 01.598.66 6.6 6.6 0 01-13.134 0 .602.602 0 01.598-.66H17.37zM15.06 7.44a3 3 0 112.499 2.363',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
